<template>
  <div
    class="card-base card-shadow--medium mb-10 widget small-widget"
    v-loading="loading"
  >
    <div class="widget-header p-20">
      <div class="flex justify-center align-center">
        <!-- Caja de icono izquierda -->
        <div class="widget-icon-box mr-20 animated fadeInRight">
          <i class="widget-icon fs-30" :class="icon"></i>
        </div>
        <!-- caja central -->
        <div class="widget-info box grow text-truncate animated fadeInLeft">
          <div class="o-050 widget-title text-center text-truncate pt-5 pb-10">
            {{ title }}
          </div>
          <h2 class="m-0 text-center text-truncate">{{ percent }}%</h2>

          <!-- Footer -->
          <div
            class="box flex grow justify-content justify-space-between pt-10"
          >
            <div class="box">
              <span style="font-size: 12px; font-weight: 700"
                >{{ objetiveCompleted }}/{{ objetiveTotal }} Obj.</span
              >
            </div>
            <div class="box">
              <span style="font-size: 12px; font-weight: 700"
                >{{ taskCompleted }}/{{ taskTotal }} Tar.</span
              >
            </div>
            <div class="box" v-if="gantt">
              <span style="font-size: 12px; font-weight: 700"
                >{{ subtaskCompleted }}/{{ subtaskTotal }} Sub.</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    icon: {
      type: String,
      default: "mdi mdi-account-multiple"
    },
    loading: {
      type: Boolean,
      default: false
    },
    percent: {
      type: Number,
      required: false
    },
    objetiveCompleted: {
      type: Number,
      required: false,
      default: 0
    },
    objetiveTotal: {
      type: Number,
      required: false,
      default: 0
    },
    taskCompleted: {
      type: Number,
      required: false,
      default: 0
    },
    taskTotal: {
      type: Number,
      required: false,
      default: 0
    },
    subtaskCompleted: {
      type: Number,
      required: false,
      default: 0
    },
    subtaskTotal: {
      type: Number,
      required: false,
      default: 0
    },
    gantt: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables";

.widget {
  position: relative;

  .widget-header {
    .widget-icon-box {
      background: rgba(0, 0, 0, 0.02);
      border: 1px solid rgba(0, 0, 0, 0.02);
      border-radius: 4px;
      text-align: center;
      width: 60px;
      padding: 5px;
    }

    .widget-title {
      font-weight: bold;
    }
  }

  .badge-box {
    .badge {
      display: inline-block;
      border-radius: 4px;
      font-size: 80%;
    }
  }
}
.timeline {
  max-width: 1200px;
  margin: 6px;
}
.timeline,
.timeline-title {
  color: $text-color;
  line-height: 1.4;
  cursor: default;
  font-family: inherit;
}

@media (min-width: 768px) and (max-width: 1040px) {
  .radio-switcher {
    display: none;
  }

  .widget {
    .widget-header {
      .widget-icon-box {
        display: none;
      }
    }
  }
}

@media (max-width: 420px) {
  .radio-switcher {
    display: none;
  }
}
</style>
